import {
  Typography,
  useTheme,
  Card,
  CardHeader,
  CardMedia,
  CardContent,
} from "@mui/material";

import { tokens } from "../theme";
import ShowProposalsModal from "../models/ShowProposalsModal";
import { useState } from "react";
// import { useSelector } from "react-redux";
// import { selectSponserName } from "../features/auth/authSlice";

const CardComp = ({
  title,
  imageUrl,
  content,
  price,
  creator,
  proposals,
  feedId,
  setFeeds,
  createdAt,
}: {
  title: string;
  imageUrl: string;
  content: string;
  price: Number;
  creator: any;
  proposals: any;
  feedId: string;
  setFeeds: React.Dispatch<any>;
  createdAt: string;
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <Card
        className="flex justify-evenly flex-col m-5 cursor-pointer"
        onClick={() => setIsModalVisible(true)}
        sx={{ maxWidth: 400 }}
      >
        <CardHeader
          // avatar={
          //   <Avatar sx={{ bgcolor: "red" }} aria-label="recipe">
          //     {sponserName[0]}
          //   </Avatar>
          // }
          title={title}
          subheader={new Date(createdAt).toDateString()}
        />
        <CardMedia
          component={"img"}
          image={process.env.REACT_APP_BACKEND_API + "/" + imageUrl}
          alt={imageUrl}
        />

        <CardContent>
          <Typography color={colors.grey[100]} variant="h4">
            {content}
          </Typography>
          <div className="flex justify-between">
            <div>
              <Typography color={colors.greenAccent[400]} variant="h3">
                {price + " Rs/-"}
              </Typography>
            </div>
          </div>
        </CardContent>
      </Card>
      {isModalVisible && (
        <ShowProposalsModal
          setIsModalVisible={setIsModalVisible}
          proposals={proposals}
          feedId={feedId}
          setFeeds={setFeeds}
        />
      )}
    </>
  );
};

export default CardComp;
